import { useSettingStore } from "@ms/stores/setting"
import { storeToRefs } from "pinia"
import { useDomThemeSwitcher } from "./useDomThemeSwitcher"
import { isCurrentPageEnabledTheme } from "@ms/utils/theme"
import { THEME_MODE } from "@ms/config/theme"
import { getBrowserThemeMode } from "@ms/utils/theme"

/**
 * @typedef {import("vue-router").Route} Route
 */

/**
 * Enable theme if the route's meta parameter `enableTheme` is true
 * @param {Route} to
 */
export const useThemeRouteFilter = (to) => {
  const domThemeSwitcher = useDomThemeSwitcher()

  if (to.meta?.enableTheme) {
    const settingStore = useSettingStore()
    const { themeMode } = storeToRefs(settingStore)

    isCurrentPageEnabledTheme.value = true

    if (themeMode.value === THEME_MODE.SYSTEM.value) {
      settingStore.setSystemThemeMode(getBrowserThemeMode())
    }
    settingStore.syncThemeTypeWithConfig()
    domThemeSwitcher.syncTheme()
  } else {
    isCurrentPageEnabledTheme.value = false
    domThemeSwitcher.switchDefaultTheme()
  }
}